module.exports = __webpack_public_path__ + "static/media/carbon-circle-sync.8d5e6652.svg";